import { RiArrowDropLeftLine, RiArrowDropRightLine } from 'react-icons/ri';
import { Button, Col, Row, TabPane } from 'reactstrap';
import { MdOutlineDocumentScanner, MdOutlineLightMode } from 'react-icons/md';
import { FaGlasses, FaRegIdCard } from 'react-icons/fa';
import './styles.css';

interface PreparationProps {
  handleChangeTabe: (tab: string) => void;
}

const Preparation: React.FC<PreparationProps> = ({ handleChangeTabe }) => {
  return (
    <TabPane tabId="2">
      <Row className="mb-2">
        <Col className="text-center">
          <h2 className="text-primary">Prepare sua verificação</h2>
          <p>Siga atentamente as dicas abaixo.</p>
        </Col>
      </Row>
      <Row className="mb-2 d-flex justify-content-center">
        <Col sm="8">
          <Row className="mb-2">
            <Col className="d-flex">
              <div className="mr-2 d-flex align-items-center">
                <span className="icons-background">
                  <FaRegIdCard size={25} />
                </span>
              </div>
              <div className="d-flex align-items-center">
                Retire a capa do seu documento e coloque-o sobre uma superfície
                plana.
              </div>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col className="d-flex">
              <div className="mr-2 d-flex align-items-center">
                <span className="icons-background">
                  <MdOutlineDocumentScanner size={25} />
                </span>
              </div>
              <div className="d-flex align-items-center">
                Posicione o seu documento na área indicada, tire uma foto da
                frente e, em seguida, da parte de trás. Se possível, evite
                posicionar o dedo sobre o documento.
              </div>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col className="d-flex">
              <div className="mr-2 d-flex align-items-center">
                <span className="icons-background">
                  <MdOutlineLightMode size={25} />
                </span>
              </div>
              <div className="d-flex align-items-center">
                Para garantir a qualidade, procure um local bem iluminado.
              </div>
            </Col>
          </Row>
          <Row className="mb-2">
            <Col className="d-flex">
              <div className="mr-2 d-flex align-items-center">
                <span className="icons-background">
                  <FaGlasses size={25} />
                </span>
              </div>
              <div className="d-flex align-items-center">
                Não use óculos ou bonés.
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex justify-content-between">
          <Button
            size="sm"
            onClick={() => handleChangeTabe('1')}
            color="secondary"
          >
            <RiArrowDropLeftLine size={25} /> Anterior
          </Button>
          <Button
            size="sm"
            onClick={() => handleChangeTabe('3')}
            color="primary"
          >
            Próximo <RiArrowDropRightLine size={25} />
          </Button>
        </Col>
      </Row>
    </TabPane>
  );
};

export default Preparation;
